import { IconButton } from '@mui/material';
import type { PlanOverview } from '@weft/api-definition';
import React from 'react';
import { PlanMenuModal } from './PlanDotMenuModal';

type PlanDotMenuProps = {
  plan: PlanOverview;
  refetchFunction: () => void;
};

export const PlanDotMenu: React.FC<PlanDotMenuProps> = ({ plan, refetchFunction }) =>{
  return (
    <div
      onClick={(event: React.MouseEvent<HTMLDivElement> & { ignore?: boolean }) => {
        event.ignore = true;
      }}
      className="flex justify-center"
    >
      <PlanMenuModal
        refetchFunction={refetchFunction}
        plan={plan}
      >
        <IconButton className='aspect-square rounded-full'>
          <span
            className='bg-icon text-label mx-2 mb-[3px] inline-block h-1 w-1 rounded-full shadow-[0_7px_0_#ADC2E2,0_-7px_0_#ADC2E2]'
          ></span>
        </IconButton>
      </PlanMenuModal>
    </div>
  );
};